// The landing page is public: it must not go through the authenticated tRPC
// client (whose token fetch sends anonymous visitors to Auth0). This is a
// plain GET of the public `access.publicBase` procedure instead.

export type PublicBase = {
  name: string;
  tagline: string | null;
  priceCents: number;
  currency: string;
  trialDays: number | null;
};

/** tRPC GET response envelope for a superjson-transformed query. */
export function unwrapPublicBase(body: unknown): PublicBase | null {
  const json = (body as { result?: { data?: { json?: unknown } } })?.result?.data?.json;
  if (!json || typeof json !== 'object') return null;
  const b = json as Partial<PublicBase>;
  if (typeof b.name !== 'string' || typeof b.priceCents !== 'number') return null;
  return {
    name: b.name,
    tagline: typeof b.tagline === 'string' ? b.tagline : null,
    priceCents: b.priceCents,
    currency: typeof b.currency === 'string' ? b.currency : 'BRL',
    trialDays: typeof b.trialDays === 'number' ? b.trialDays : null,
  };
}

export async function fetchPublicBase(apiUrl: string, signal?: AbortSignal): Promise<PublicBase | null> {
  try {
    const res = await fetch(`${apiUrl.replace(/\/$/, '')}/access.publicBase`, { signal, headers: { Accept: 'application/json' } });
    if (!res.ok) return null;
    return unwrapPublicBase(await res.json());
  } catch {
    return null;
  }
}
